import * as React from 'react';

import { Tooltip } from '@base-ui/react/tooltip';

import { cn } from 'utils/cn';

const ShadTooltipProvider = Tooltip.Provider;

const ShadTooltip = Tooltip.Root;

const ShadTooltipTrigger = Tooltip.Trigger;

const ShadTooltipContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof Tooltip.Popup> & {
    sideOffset?: number;
    side?: 'top' | 'right' | 'bottom' | 'left';
    align?: 'start' | 'center' | 'end';
    hidden?: boolean;
  }
>(
  (
    {
      className,
      sideOffset = 4,
      side = 'top',
      align = 'center',
      hidden,
      children,
      ...props
    },
    ref,
  ) => {
    if (hidden) return null;

    return (
      <Tooltip.Portal>
        <Tooltip.Positioner side={side} align={align} sideOffset={sideOffset}>
          <Tooltip.Popup
            ref={ref}
            className={cn(
              'z-tooltip overflow-hidden rounded-xSmall',
              'bg-background-primary px-xs3 py-xs1',
              'text-body-small text-primary-inverse',
              'animate-in fade-in-0 zoom-in-95',
              className,
            )}
            {...props}
          >
            {children}
          </Tooltip.Popup>
        </Tooltip.Positioner>
      </Tooltip.Portal>
    );
  },
);
ShadTooltipContent.displayName = 'ShadTooltipContent';

export {
  ShadTooltip,
  ShadTooltipContent,
  ShadTooltipProvider,
  ShadTooltipTrigger,
};
